import { useState } from "react";
import { Tooltip, IconButton } from "@mui/material";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import { useTranslation } from "react-i18next";

import AppContext from "../../../Contexts/AppContext";
import { useContext } from "react";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import DownloadIcon from "@mui/icons-material/Download";
import { getLayerGeojson } from "../../../../api/ApiLayers";
import { toast } from "react-toastify";
const DownloadGeojsonTool = ({ layer }) => {
  const { t, i18n } = useTranslation("main");

  const handleDownloadGeojson = async () => {
    const toast_id = toast.loading(`${t("downloading_geojson")}...`, {
      position: "top-right",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    try {
      const geojson = await getLayerGeojson(layer.uuid);
      console.log("GeoJSON data:", geojson, typeof geojson);
      const blob = new Blob([JSON.stringify(geojson)], {
        // const blob = new Blob(geojson, {
        type: "application/json",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      const filename = `${layer.name[i18n.language].replaceAll(" ", "_")}_${layer.uuid}.geojson`;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url); // limpieza del objeto URL

      toast.update(toast_id, {
        render: t("geojson_downloaded_successfully"),
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });
    } catch (error) {
      console.error("Error al descargar el GeoJSON:", error);

      toast.update(toast_id, {
        render: t("geojson_downloading_error"),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  return (
    <Tooltip title={t("download_geojson")}>
      <IconButton
        className={"layerGroupTool-element"}
        onClick={handleDownloadGeojson}
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  );
};
export { DownloadGeojsonTool };
